import { Injectable } from '@angular/core';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';

@Injectable({
  providedIn: 'root'
})
export class InjectableTranslateMessageFormatCompilerService extends TranslateMessageFormatCompiler{
}
